module.exports = __webpack_public_path__ + "img/romantik-guide6.6ff3b852.jpg";